import { Store } from "../../types/contexts/groupContext/store.types";
import { Group } from "../../types/group.types";

const initialState: Store = {
	group: {} as Group
};

export default initialState;
